

module.exports = __webpack_require__.stylable.create(
    "Popover940911077",
    {"classes":{"root":"Popover940911077__root","popoverContent":"Popover525086061__popoverContent","popover":"Popover525086061__popover","arrow":"Popover525086061__arrow","overrideStyleParams":"Popover940911077__overrideStyleParams"},"vars":{},"stVars":{"defaultBackgroundColor":"\"color(color-1)\"","defaultBorderColor":"rgba(255, 255, 255, .4)","defaultBorderRadius":"0","defaultPadding":"20px","BackgroundColor":"--overridable","BorderColor":"--overridable","BorderRadius":"--overridable","Padding":"--overridable","backgroundColor":"\"color(fallback(--overridable, color(color-1)))\"","borderColor":"\"color(fallback(--overridable, rgba(255, 255, 255, .4)))\"","borderRadius":"\"fallback(--overridable, 0)\"","padding":"\"fallback(--overridable, 20px)\""},"keyframes":{}},
    "",
    2,
    "Popover940911077",
    null
);
